import Vue from 'vue';
import WorkMultipleSelectionFilter
  from '@/components/global_components/filters/multiple_selection_filter/WorkMultipleSelectionFilter';
import WorkMultipleSelectionFilterLazy
  from '@/components/global_components/filters/multiple_selection_filter/WorkMultipleSelectionFilterLazy';
import WorkMultipleTreeSelectionFilter
  from '@/components/global_components/filters/multiple_selection_filter/WorkMultipleTreeSelectionFilter';
import WorkMultipleKeyValueFilter 
  from '@/components/global_components/filters/multiple_selection_filter/WorkMultipleKeyValueFilter';

Vue.component('WMultipleSelectionFilter', WorkMultipleSelectionFilter);
Vue.component('WMultipleSelectionFilterLazy', WorkMultipleSelectionFilterLazy);
Vue.component('WMultipleTreeSelectionFilter', WorkMultipleTreeSelectionFilter);
Vue.component('WMultipleKeyValueFilter', WorkMultipleKeyValueFilter);